/**
 * GameBackgroundLandscapeProperties.ts
 */
import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { GameBackgroundProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameBackgroundProperties";
import { PawnAssetStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/PawnAssetStyle";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { Point } from "pixi.js";
export class GameBackgroundLandscapeProperties extends GameBackgroundProperties {
    constructor() {
        super(...arguments);
        this.frameProperties = new SpriteProperties(PawnAssetStyle.Frame.landscape, GameStyle.MODULE, new Point(574, 0));
        this.baseBackgroundProperties = new SpriteProperties(PawnAssetStyle.Background.landscape, GameStyle.MODULE, new Point(0, -461));
    }
}
